import React from "react";
import Checkout5 from "../components/Checkout5";

const checkout5 = () => {
  return <Checkout5 />;
};

export default checkout5;
